import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { setDefaultOptions } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { FieldInputProps, FormikProps, FormikValues } from 'formik';
import React from 'react';

type Props = {
  field: FieldInputProps<string>;
  form: FormikProps<FormikValues>;
  error: boolean;
  label: string;
};

const TimePicker = ({ field, form, error, label }: Props) => {
  const { name, value } = field;
  const { setFieldValue } = form;

  React.useEffect(() => {
    setDefaultOptions({
      locale: enUS,
    });
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiTimePicker
        label={label}
        value={value ? new Date(value) : null}
        onChange={(time) => {
          setFieldValue(name, time);
        }}
        slotProps={{
          textField: {
            variant: 'outlined',
            fullWidth: true,
            error: error,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;
